import _regeneratorRuntime from "@babel/runtime/regenerator";
import EntityTypes from '../../types/EntityTypes';
import { scanUntilAtSign } from '../utils/getSearchText';
import insertEntity from '../utils/insertEntity';
export function UserStrategy(_ref) {
  var fetchUsers = _ref.fetchUsers,
      getCurrentUser = _ref.getCurrentUser;
  var strategy = {
    index: 1,
    apply: function apply(item, editor) {
      insertEntity(editor, scanUntilAtSign, '@' + item.data.username, EntityTypes.MENTION, {
        userId: item.data.id
      }).insertText(' ');
    },
    search: function search(query) {
      var users, currentUser;
      return _regeneratorRuntime.async(function search$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _regeneratorRuntime.awrap(fetchUsers(query.toLowerCase()));

            case 2:
              users = _context.sent;
              currentUser = query === '' ? [{
                type: 'users',
                data: getCurrentUser(),
                strategy: strategy,
                index: 0
              }] : [];
              return _context.abrupt("return", currentUser.concat(users.map(function (userData) {
                return {
                  type: 'users',
                  data: userData,
                  strategy: strategy,
                  index: 1
                };
              })));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      });
    },
    tokenize: function tokenize(item) {
      return (item.data.username + item.data.displayName + item.data.email).toLowerCase();
    }
  };
  return strategy;
}
export function NoteStrategy(_ref2) {
  var fetchNotes = _ref2.fetchNotes;
  var strategy = {
    index: 2,
    apply: function apply(item, editor) {
      insertEntity(editor, scanUntilAtSign, item.data.title || 'Untitled', EntityTypes.NOTELINK, {
        noteId: item.data.id
      }).insertText(' ');
    },
    search: function search(query) {
      var notes;
      return _regeneratorRuntime.async(function search$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _regeneratorRuntime.awrap(fetchNotes(query.toLowerCase()));

            case 2:
              notes = _context2.sent;
              return _context2.abrupt("return", notes.map(function (noteData, index) {
                return {
                  type: 'notes',
                  data: noteData,
                  strategy: strategy,
                  // Preserve search index
                  index: index + strategy.index
                };
              }));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      });
    },
    tokenize: function tokenize(item) {
      return (item.data.title || '').toLowerCase();
    }
  };
  return strategy;
}